// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Layout } from '~/components';

import { Users } from '../pages';

function UserRoutes(): ReactElement {
  return (
    <Layout title="Treinadores">
      <Route path="/users" exact component={Users.UsersList} />
      <Route path="/users/details/:id" exact component={Users.Details} />
      <Route
        path="/users/details/:id/students"
        exact
        component={Users.StudentsList}
      />
      <Route
        path="/users/details/:id/payments"
        exact
        component={Users.PaymentHistoric}
      />
      <Route
        path="/users/details/:id/packages"
        exact
        component={Users.Packages}
      />
      <Route
        path="/users/details/:id/packages/edit/:packageId"
        exact
        component={Users.EditPackage}
      />
      <Route
        path="/users/details/:id/packages/:packageId"
        exact
        component={Users.PackageDetail}
      />
      <Route path="/users/cadaster" exact component={Users.UserCadaster} />
      <Route path="/users/edit/:id" exact component={Users.EditUser} />
      <Route
        path="/users/details/student/:id"
        exact
        component={Users.StudentDetails}
      />
    </Layout>
  );
}

export default UserRoutes;
